import { Injectable } from '@nestjs/common';
import { PlantCapacity } from '../plant-capacity.entity';
import { PlantCapacityDTO } from './plant-capacity-dto.';

@Injectable()
export class PlantCapacityAdapter {
  
  public convertDtoToEntity(plantCapacityDTO: PlantCapacityDTO,  isUpdate: boolean = false ): PlantCapacity {
    const resourceoperationEfficiency = new PlantCapacity();
    resourceoperationEfficiency.plantCapacityId=plantCapacityDTO.plantCapacityId;
    resourceoperationEfficiency.operation=plantCapacityDTO.operation;
    resourceoperationEfficiency.plantCode=plantCapacityDTO.plantCode;
    resourceoperationEfficiency.machineCapacity=plantCapacityDTO.machineCapacity;
    resourceoperationEfficiency.peopleCapacity=plantCapacityDTO.peopleCapacity;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    resourceoperationEfficiency.isActive=plantCapacityDTO.isActive==undefined?true:plantCapacityDTO.isActive;
    if (isUpdate) {
        resourceoperationEfficiency.updatedUser = plantCapacityDTO.updatedUser;
    } else {
      resourceoperationEfficiency.isActive = true;
      resourceoperationEfficiency.createdUser = plantCapacityDTO.createdUser;
    }
   return resourceoperationEfficiency;
  }
  public convertEntityToDto(plantCapacityObject: PlantCapacity): PlantCapacityDTO {
    const resourceOperationEfficiencyDTO= new PlantCapacity;
    resourceOperationEfficiencyDTO.plantCapacityId=plantCapacityObject.plantCapacityId;
    resourceOperationEfficiencyDTO.plantCode=plantCapacityObject.plantCode;
    resourceOperationEfficiencyDTO.machineCapacity=plantCapacityObject.machineCapacity;
    resourceOperationEfficiencyDTO.peopleCapacity=plantCapacityObject.peopleCapacity;
    resourceOperationEfficiencyDTO.isActive = plantCapacityObject.isActive;
    resourceOperationEfficiencyDTO.operation=plantCapacityObject.operation;
    resourceOperationEfficiencyDTO.createdAt = plantCapacityObject.createdAt;
    resourceOperationEfficiencyDTO.updatedAt = plantCapacityObject.updatedAt;
    resourceOperationEfficiencyDTO.createdUser = plantCapacityObject.createdUser;
    resourceOperationEfficiencyDTO.updatedUser = plantCapacityObject.updatedUser;
    resourceOperationEfficiencyDTO.versionFlag = plantCapacityObject.versionFlag;
    return resourceOperationEfficiencyDTO;
  }
}
